<template>
	<div id="page-master-role-create">
		<div class="vx-row w-full">
			<div class="vx-col w-1/2">
				<vx-card class="mb-base w-full" title="Form Purchase Order">
					<div class="vx-row">
						<div class="vx-col w-full mt-2 mb-2">
							<vs-select
								autocomplete
								:disabled="disable"
								class="w-full"
								name="supplier"
								label="Nama Supplier"
								v-model="supplier"
								v-on:change="supChg(false)"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item,index) in listSupplier"
								/>
							</vs-select>
						</div>
						<div class="vx-col w-full mt-2 mb-2">
							<label for class="vs-input--label">Tanggal Order</label>
							<datepicker
								name="startDate"
								placeholder="Tanggal Order"
								label="Tanggal Order"
								format="dd/MM/yyyy"
								v-model="startDate"
							></datepicker>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col w-1/2">
				<vx-card class="mb-base w-full">
					<template slot="actions">
						<vs-button class="ml-10" @click="activePromptProduct = true" color="primary">Tambah Produk</vs-button>
					</template>
					<div class="vx-row">
						<div class="vx-col w-full mt-2 mb-2">
							<vs-table stripe :data="listPurchase">
								<template slot="thead">
									<vs-th>Nama Produk</vs-th>
									<vs-th>Qty</vs-th>
									<vs-th>#</vs-th>
								</template>
								<template slot-scope="{data}">
									<vs-tr :key="indextr" v-for="(tr, indextr) in data">
										<vs-td>{{data[indextr].product.name}}</vs-td>
										<vs-td>{{data[indextr].qty}}</vs-td>
										<vs-td vs-align="center">
											<vs-button @click="delRowProduct(indextr)" color="danger">Hapus</vs-button>
										</vs-td>
									</vs-tr>
								</template>
							</vs-table>
						</div>
					</div>
				</vx-card>
			</div>
		</div>
		<div class="vx-col w-full">
			<div class="flex flex-end items-start mb-4">
				<vs-button
					class="mr-4 mb-4"
					color="danger"
					@click="$router.push('/stock/purchase').catch(() => {})"
				>Batal</vs-button>
				<vs-button class="mr-4 mb-4" icon-pack="feather" @click="onConfirm">Simpan</vs-button>
			</div>
		</div>

		<vs-prompt
			title="Form Tambah Produk"
			@accept="acceptProduct"
			accept-text="Tambah"
			cancel-text="Batal"
			:active.sync="activePromptProduct"
		>
			<div class="con-exemple-prompt">
				<div class="vx-col w-full mt-2 mb-2">
					<vs-select
						autocomplete
						class="w-full"
						name="product"
						label="Nama Produk"
						v-model="product"
					>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.name"
							v-for="(item,index) in listProduct"
						/>
					</vs-select>
				</div>
				<div class="vx-col w-full mt-2 mb-2">
					<vs-input class="w-full" v-model="qty" label="Qty" />
				</div>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import ref from "@/api/ref.js";
import formsearch from "@/api/form-search.js";
import stock from "@/api/stock.js";
import tool from "@/tool/form_tool.js";
import master from "@/api/master.js";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
	components: {
		Datepicker,
	},
	data() {
		return {
			id: this.$route.params.id,
			supplier: "",
			isEdit: (!this.$route.params.type? true:(this.$route.params.type=='update'?true:false)),
			disable: false,
			activePromptProduct: false,
			startDate: "",
			description: "",
			product: "",
			listPurchase: [],
			listSupplier: [],
			listProduct: [],
			qty: "",
			product: "",
		};
	},
	methods: {
		async firstLoad() {
			await this.getSupplier();
			if (this.id) {
				const prev = await stock.getPurchaseOrder(this.id);
				if (prev.data.status) {
					var res = prev.data.data[0];
					this.supplier = res.supplierId;
					this.startDate = moment(res.purchaseDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
					var t = [];
					for (var i = 0; i < res.purchaseLine.length; i++) {
						var s = res.purchaseLine[i];
						var o = {qty: s.qty, product: {id:s.productId, name:s.productName}};
						t.push(o);
					}
					this.listPurchase = t;
				}
			}
		},
		onConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "warning",
				title: `Konfirmasi`,
				text: "Simpan data ?",
				acceptText: "Ya",
				cancelText: "Tidak",
				accept: this.submitData,
			});
		},
		submitData() {
			const data = {
				purchaseDate: moment(this.startDate).format('YYYY-MM-DD'),
				supplier: {id: this.supplier},
				purchaseLine: this.listPurchase,
			};

			if (this.id) {
				data.id = this.id;
			}

			let config = {
				headers: {
					"content-type": "application/json",
				},
			};

			stock.savePurchaseOrder(data, config)
				.then((res) => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text:
								"Data telah berhasil di submit",
							color: "success",
							position: "top-right",
						});
						this.$router.push("/stock/purchase");
					} else {
						this.$vs.notify({
							title:
								"Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right",
						});
					}
				})
				.catch((error) => {
					if (error.response) {
						this.$vs.notify({
							title:
								"An Error Occured",
							time: 3000,
							text:
								error.response
									.data
									.message,
							color: "danger",
							position: "top-right",
						});
					}
				});
		},
		async getSupplier() {
			const prov = await master.listSupplier();
			this.listSupplier = prov.data.data;
		},
		acceptProduct() {
			const pd = this.product;
			const pq = this.qty;
			this.product = "";
			this.qty = "";
			var xpd = "";

			this.listProduct.forEach(function (e) {
				if (e.id == pd) {
					xpd = e;
				}
			});

			const obj = {product: {id: xpd.id, name: xpd.name}, qty: pq};
			this.listPurchase.push(obj);
		},
		delRowProduct(idx) {
			console.log(idx);
			this.listPurchase.splice(idx, 1);
			console.log(this.listPurchase);
		},	
		async supChg(first) {
			if (!first) {
				this.listPurchase = [];
				if (this.supplier) {
					const mst = {supplierId: this.supplier};
					const dt = await master.listProduk(mst);
					this.listProduct = dt.data.data;
				}
			}

		},
	},
	mounted() {},
	created() {
		this.firstLoad();
	},
};
</script>

<style lang="scss" scoped>
.bordered {
	border-width: 1px;
	border-radius: 4px;
	box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
	margin: 0;
}
.vx-custom-remove-icon {
	text-align: right;
}
.vs-textarea-primary.focusx {
	border: 1px solid #0056a8 !important;
	box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
}
.vs-checkbox-default {
	transform: translate(0, -70%);
	top: 70%;
}
</style>
